var Emitter = require('../../emitter')

var Transform = Emitter.extend(
  /** @lends Transform.prototype */

  /**
   * Transform classes among youbora helps the library parse and work with data.
   * ResourceTransform, ViewTransform... all extend from this class.
   *
   * @constructs Transform
   * @extends Emitter
   * @memberof youbora
   * @abstract
   */
  {
    constructor: function () {
      this._isBusy = true
    },

    /**
     * Override this method to transform info.
     *
     * @param {YBRequest} request Request to transform.
     */
    parse: function (request) { },

    /**
     * Returns if transform is blocking.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */
    isBlocking: function (request) {
      return this._isBusy
    },

    /**
     * Emits DONE event
     */
    done: function () {
      this._isBusy = false
      this.emit(Transform.Event.DONE)
    }
  },

  /** @lends Transform */
  {
    // Static members

    /**
     * List of events that could be fired from this class.
     * @enum
     */
    Event: {
      /** Notifies that this Transform is done processing. */
      DONE: 'done'
    }
  }
)

module.exports = Transform



//////////////////
// WEBPACK FOOTER
// ./src/comm/transform/transform.js
// module id = 4
// module chunks = 0